enum Creator {
  User = 'User',
  Group = 'Group',
}

export default Creator;
